export default "__VITE_ASSET__C8f3l4CD__"